import { ProgressSpinner } from "primereact/progressspinner";
import styled from "styled-components";
import { ViewType } from "./TimeNavigation";
import { theme } from "styles/theme";

const GridLoadingContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 1.5rem;
  padding: 0.5rem 0;

  @media (max-width: ${theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }

  @media (min-width: ${theme.breakpoints.desktop}) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const LoadingSlot = styled.div`
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  background: transparent;
  border: none;
  color: ${theme.colors.textSecondary};
  font-size: ${theme.fontSizes.small};
`;

const ListLoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const CombinedLoadingContainer = styled(LoadingSlot)`
  min-height: 320px;
  margin-bottom: 1rem;
`;

interface ChartsLoadingSpinnerProps {
  viewType: ViewType;
}

function LoadingContent() {
  return (
    <>
      <ProgressSpinner
        style={{ width: "42px", height: "42px" }}
        strokeWidth="4"
        aria-hidden
      />
      <span>Loading chart data...</span>
    </>
  );
}

export function ChartsLoadingSpinner({ viewType }: ChartsLoadingSpinnerProps) {
  if (viewType === "combined") {
    return (
      <CombinedLoadingContainer role="status" aria-live="polite" aria-busy="true">
        <LoadingContent />
      </CombinedLoadingContainer>
    );
  }

  if (viewType === "list") {
    return (
      <ListLoadingContainer>
        {Array.from({ length: 3 }, (_, index) => (
          <LoadingSlot
            key={index}
            role="status"
            aria-live="polite"
            aria-busy="true"
          >
            <LoadingContent />
          </LoadingSlot>
        ))}
      </ListLoadingContainer>
    );
  }

  return (
    <GridLoadingContainer>
      {Array.from({ length: 3 }, (_, index) => (
        <LoadingSlot
          key={index}
          role="status"
          aria-live="polite"
          aria-busy="true"
        >
          <LoadingContent />
        </LoadingSlot>
      ))}
    </GridLoadingContainer>
  );
}
